<template>
  <div class="servicios">
    <v-container fluid class="py-0">
      <v-row class="text-center d-md-none" style="height: 106px;">
        <v-col cols="12" class="azul">
          <div class="texto-centro">
            <router-link to="/">
              <v-img
                src="@/assets/img/logo/logo-blanco.png"
                class="d-block mx-auto"
                width="80px"
              ></v-img>
            </router-link>
          </div>
        </v-col>
      </v-row>
      <v-row class="text-center" style="height: 200px;">
        <v-col cols="12" md="6" class="azul">
          <div class="texto-centro">
            <h1 style="color:white; font-weight: normal;" class="exo texto-mobile-size">Retina</h1>
          </div>
        </v-col>
        <v-col cols="12" md="6" style="position:relative;" class="before-column pt-0">
          <div class="texto-centro">
            <h3 class="azul_oscuro gotham texto-mobile-2">Tus ojos no tienen precio.</h3>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row class="my-8 my-md-12" justify="center">
        <v-col cols="12" offset-md="2" md="8" class="padding-column">
          <v-img
            src="@/assets/img/iconografiaServicios/retina.svg"
            width="60"
            class="mb-2 d-none d-md-block"
          ></v-img>

          <v-img
            src="@/assets/img/iconografiaServicios/retina.svg"
            width="137px"
            class="mx-auto d-block d-md-none"
          ></v-img>
          <span
            class="gotham-bold subtitulo-size azul_oscuro d-block text-center text-md-left"
          >¿Qué es?</span>
          <hr style="border: 1px solid #6C8FC9; width: 30%" class="d-block d-md-none mx-auto" />

          <p class="gotham azul_oscuro d-block mt-10 px-6 px-md-0 propiedades-parrafos">
            La retina es una capa de células altamente organizadas en el interior del ojo que recibe la
            lúz y la envía a través del nervio óptico al cerebro para crear la visión.Si hay alteraciones
            en la retina, la visión será alterada.
          </p>

          <section class="mt-10 px-6 px-md-0">
            <span
              class="gotham-bold azul_oscuro d-block mt-10"
              style="max-width: 735px; font-size: 20px;"
            >Los síntomas más comunes son:</span>

            <ul class="azul_oscuro mt-6 gotham">
              <li>Manchas que aparecen flotando en la visión</li>
              <li>Pérdida de la visión</li>
              <li>Visión que cambia de borrosa a clara</li>
              <li>Áreas oscuras completas o parciales en el campo de la visión</li>
              <li>Mala visión nocturna</li>
              <li>Colores que se visualizan como descoloridos o diferentes</li>
            </ul>
          </section>

          <span
            class="gotham-bold azul_oscuro d-block mt-10 px-6 px-md-0 examenes-periodicos-texto"
          >
            En Visión Láser San Luis contamos con especialistas que le ayudarán para la detección y
            tratamiento oportuno.
          </span>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>


export default {

};
</script>